<address *ngIf="address">
  <a (click)="openMap($event)">
    {{address.Address1}}
    <br/>
    {{address.Address2}}
    <br *ngIf="address.Address2" />
    {{address.City}}<span *ngIf="address.City && (address.State || address.Zip)">,</span> {{address.State}} {{address.Zip}}
    {{address.Country}}
  </a>
</address>